import React, { useState } from "react";
import * as Animate from "react-reveal";
import { Link } from "react-router-dom";

import SchoolImage1 from "../../../assets/images/png/individual/school1.webp";
import kickStartDataAfrica from "./data/kickStartDataAfrica";
import kickStartDataEurope from "./data/kickStartDataEurope";

const Card = ({ bgColor, title, image, selectedTab }) => {
  return (
    <div className="rounded-xl card">
      <div className="relative card-header rounded-tl-xl rounded-tr-xl">
        <img
          src={image || SchoolImage1}
          className="object-cover rounded-tl-xl rounded-tr-xl"
          alt=""
        />

        <div className="card-header-tag absolute top-6 left-6 px-3 py-2">
          <p className="font-medium uppercase">
            <span>
              {selectedTab === 1 ? "Bootcamp" : "Bootcamp + Internship"}
            </span>
            <span>⚡</span>
          </p>
        </div>
      </div>

      <div
        className="px-6 lg:px-10 py-10 rounded-b-xl"
        style={{
          background: bgColor || "#050794",
        }}
      >
        <p
          className={`text-white text-xl lg:text-2xl ${
            selectedTab === 1 ? "w-11/12 lg:w-9/12" : "w-full lg:w-full"
          }`}
        >
          {title}
        </p>
        <div className="mt-6 flex">
          <p className="text-white text-link-hover font-mono text-base lg:text-lg flex items-center pr-3">
            View Courses{" "}
            <span className="pl-5">
              <svg
                className="w-4 h-3"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9144 8.62188C16.3018 8.23447 16.3018 7.60635 15.9144 7.21894L9.60115 0.905697C9.21374 0.518285 8.58562 0.518285 8.19821 0.905697C7.81079 1.29311 7.81079 1.92123 8.19821 2.30864L13.81 7.92041L8.19821 13.5322C7.81079 13.9196 7.81079 14.5477 8.19821 14.9351C8.58562 15.3225 9.21374 15.3225 9.60115 14.9351L15.9144 8.62188ZM0.740723 8.91244L15.2129 8.91244L15.2129 6.92838L0.740723 6.92838L0.740723 8.91244Z"
                  fill="#ffffff"
                />
              </svg>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

const TabButton = ({ title, isActive, handleChangeTab }) => {
  return (
    <button
      className={`text-sm md:text-base lg:text-lg learning-tab-button focus:outline-none ${
        isActive ? "active" : ""
      }`}
      onClick={handleChangeTab}
    >
      {title}
    </button>
  );
};

const KickStartSection = ({ title }) => {
  const [selectedTab, setSelectedTab] = useState(1);

  const [selectedData, setSelectedData] = useState(kickStartDataAfrica);

  const handleChangeTab = (val) => {
    setSelectedTab(val);
    if (val === 1) {
      setSelectedData(kickStartDataAfrica);
    } else {
      setSelectedData(kickStartDataEurope);
    }
  };

  return (
    <section id="kickstart" className=" pb-24 lg:pb-28 bg-white">
      <div className="container mx-auto px-4">
        <div className="w-full md:w-9/12 lg:w-8/12 xl:w-6/12">
          <Animate.Fade bottom>
            <h2 className="text-primary text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
              {title || "What is the Best Learning Program for You?"}
            </h2>
          </Animate.Fade>
        </div>

        <div className="mt-12 lg:mt-14 relative">
          <div className="flex flex-row space-x-4 lg:space-x-8">
            <TabButton
              title={"Bootcamp"}
              handleChangeTab={() => handleChangeTab(1)}
              isActive={selectedTab === 1 && true}
            />
            {/* <TabButton
              title={"Bootcamp + Internship"}
              handleChangeTab={() => handleChangeTab(2)}
              isActive={selectedTab === 2 && true}
            /> */}
          </div>

          <div className="mt-8 lg:mt-12 relative grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-10">
            {selectedData?.length > 0 &&
              selectedData?.map((datum) => (
                <Link
                  key={datum?.id}
                  to={datum?.url}
                  className="rounded-xl h-full relative"
                >
                  <Card
                    key={datum?.id}
                    title={datum?.title}
                    image={datum?.image}
                    bgColor={datum?.bgColor}
                    selectedTab={selectedTab}
                  />
                </Link>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KickStartSection;
